export default __webpack_public_path__ + "static/media/product_healthCheck_Hk.da33d077.webp";